export default {
  title: 'Følg din ordre',
  text: 'Tak fordi du bestiller her! Vores <0>{{carrier}}</0>-partnerskab gør det muligt for os at håndtere leveringer direkte på vores side, hvilket i gennemsnit sparer os {{savings}} i leveringsprovision. Din ordre bliver leveret af <1>{{carrier}}</1>, så du får en god service 😊',
  labels: {
    delivered_by: 'Leveret af',
  },
  buttons: {
    track_order: 'Få live-opdateringer om ordren →',
    track_order_once_confirmed: 'Få live-opdateringer, når ordren er bekræftet',
  },
};
